(function (app) {

    app.constant("capturePoints",
    [
        { Name: "Needed Documents" },
        { Name: "RetireUp" },
        { Name: "Households" },
        { Name: "Questionnaire" },
        { Name: "Finances" },
        { Name: "Funding" }
    ]);

})(window.app); //jshint ignore:line